import styles from './TimeField.module.css';

interface TimeFieldProps {
    value: string;
    setValue: (value: string) => void;
    error?: string;
}

export function TimeField({ value, setValue, error }: TimeFieldProps) {
    return (
        <div className={styles.wrapper}>
            <input
                type="time"
                className={`${styles.input} ${error ? styles.inputError : ''}`}
                value={value}
                onChange={(e) => setValue(e.target.value)}
                aria-invalid={!!error}
            />
            {error && <span className={styles.errorMsg} role="alert">{error}</span>}
        </div>
    );
}
